/**
 * studentActivityCongratsViewModel — la fin d'une activité rendue, en props de
 * `<StudentActivityCongratsPage>`. Pur.
 *
 * Ce que l'activité a rapporté vient du moteur (`activityCongrats` : l'XP, les pétales, le chrono) ;
 * qui célèbre et son mot (`studentActivityCelebration`, par `celebrationFor` : le champion du jour, ou
 * Sam après une activité menée avec lui), tiré à part pour que l'écran le garde le temps des félicitations. La suite : l'activité suivante avec Sam (la séance Sam en a une), sinon la suivante de la
 * todo, sinon la liste.
 */
import {
    activityCongrats,
    celebrationFor,
    type ApiFinalizeResult,
} from "../../../../../engine/activity/celebration/activityCongrats"
import { type CelebrationChampion } from "../../../../../engine/activity/celebration/celebration"

/** `activity` : soumise en Dialogue, l'élève revient sur l'activité (le masteur est là, Wajih 25/10). */
export type ActivityCongratsNextKind = "next" | "sam" | "activities" | "activity"

export type StudentActivityCongratsModel = {
    champion: CelebrationChampion
    title: string
    /** La phrase sous le mot, quand la banque en a une (l'ancien écran l'écrivait). */
    subtitle?: string
    xp: number
    petals: number
    durationSeconds: number
    next: ActivityCongratsNextKind
}

/** Qui célèbre, et son mot : tiré une fois par activité finie (le crochet de l'écran le garde). */
export type StudentActivityCelebration = { champion: CelebrationChampion; title: string; subtitle?: string | null }

export type StudentActivityCelebrationInput = {
    user: { id?: number | null; xp?: number | null } | null
    /** Les activités finies du jour, les plus récentes d'abord (`getTodaysFinishedActivities`). */
    finishedToday: { finished_at?: string | null }[]
    /** L'activité était menée avec Sam. */
    withSam: boolean
    random?: () => number
}

export function studentActivityCelebration(input: StudentActivityCelebrationInput): StudentActivityCelebration {
    return celebrationFor(input.user, input.finishedToday, {
        champion: input.withSam ? "sam" : undefined,
        random: input.random,
    })
}

export type StudentActivityCongratsInput = {
    result: ApiFinalizeResult | null
    celebration: StudentActivityCelebration
    /** L'activité était menée avec Sam. */
    withSam: boolean
    /** Une activité suivante existe. */
    hasNext: boolean
    /** Soumise en Dialogue : l'élève revient sur l'activité, il ne passe pas à la suivante. */
    stays?: boolean
}

export function studentActivityCongratsModel(input: StudentActivityCongratsInput): StudentActivityCongratsModel {
    const gains = activityCongrats(input.result)
    return {
        champion: input.celebration.champion,
        title: input.celebration.title,
        subtitle: input.celebration.subtitle ?? undefined,
        xp: gains.xp,
        petals: gains.petals,
        durationSeconds: gains.durationSeconds,
        next: input.stays ? "activity" : !input.hasNext ? "activities" : input.withSam ? "sam" : "next",
    }
}
